<div class="banner">
  <div class="row align-items-center">
    <div class="col-lg-3">
      <div class="img-cross-format">
        <img [src]="(images()?.[0] ?? fallbackMedia[0]) | imageUrl:imageTransformations" [alt]="images()?.[0]?.alt_text">
        <img [src]="(images()?.[1] ?? fallbackMedia[1]) | imageUrl:imageTransformations" [alt]="images()?.[1]?.alt_text">
      </div>
    </div>
    <div class="col-lg-9">
      <div class="row flex-lg-row-reverse align-items-center">
        <div class="col-lg-4">
          <div class="img-cross-format right">
            <img [src]="(images()?.[2] ?? fallbackMedia[2]) | imageUrl:imageTransformations" [alt]="images()?.[2]?.alt_text">
            <img [src]="(images()?.[3] ?? fallbackMedia[3]) | imageUrl:imageTransformations" [alt]="images()?.[3]?.alt_text">
          </div>
        </div>
        <div class="col-lg-8 mt-3 mt-lg-0 d-flex flex-wrap justify-content-center align-items-center text-center" *transloco="let t">
          @if (titleText || titleTranslationKey) {
            <h4 class="title">{{titleText ?? t(titleTranslationKey)}}</h4>
          }
          @if (descriptionText || descriptionTranslationKey) {
            <p>{{descriptionText ?? t(descriptionTranslationKey)}}</p>
          }
          @if (buttonLabelText || buttonLabelTranslationKey) {
            <button class="btn btn-primary mt-2" (click)="doLinkClick()">{{buttonLabelText ?? t(buttonLabelTranslationKey)}}</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>